import React, {useEffect, useState, useCallback, useMemo} from 'react';
import axios from 'axios';
import {Button, Table, message, Spin, Row, Col, Card, Form, Modal, Input, Select, Typography} from 'antd';
import {ReloadOutlined, CloudDownloadOutlined, CloseOutlined, ImportOutlined, FileTextOutlined, ClearOutlined} from "@ant-design/icons";
import {FaFileInvoice, FaBoxes, FaUserTie} from "react-icons/fa";
import {useTranslation} from "react-i18next";
import _ from "lodash";

const { Title } = Typography;
const { Search } = Input;

export const Axios = axios.create({
    baseURL: process.env.REACT_APP_APPI_ADDRESS
});

const Manifiesto = () => {

    if(sessionStorage.getItem('user_mod'))
       sessionStorage.removeItem('user_mod');

    const { t } = useTranslation();
    //const [bottom] = useState('bottomCenter');
    const [original, setOriginal] = useState([]);
    const [data, setData] = useState([]);
    const [spinning, setSpinning] = useState(false);
    const [spinTitle, setSpinTitle] = useState(t('global.loading'));
    const [messageApi, contextHolder] = message.useMessage();
    // const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchValue, setSearchValue] = useState(''); // Estado para controlar el valor del input
    const [filteredInfo, setFilteredInfo] = useState({}); // Estado para controlar los filtros de columnas
    const [isModalImportOpen, setIsModalImportOpen] = useState(false); // Modal de importación
    const [isModalPreviewOpen, setIsModalPreviewOpen] = useState(false); // Modal de vista previa
    const [previewData, setPreviewData] = useState(null); // Datos de vista previa
    const [importFormData, setImportFormData] = useState(null); // Datos del formulario para importar
    const [formImport] = Form.useForm();
    const [formValues, setFormValues] = useState({}); // Valores del formulario para validación
    const [isModalDuplicateOpen, setIsModalDuplicateOpen] = useState(false); // Modal de manifiesto duplicado
    const [duplicateData, setDuplicateData] = useState(null); // Datos del manifiesto duplicado

    const recargar = useCallback(() => {
        const headers = {
            'accept': '*/*',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
            'Content-Type': 'application/json',
        };

        //limpiar la busqueda del componente Search
        setSearchValue('');
        setFilteredInfo({});

        setSpinTitle(t('global.loading'));
        setSpinning(true);
        //setSelectedRowKeys([]);
        let aux = [];

        // let start = 0;
        // let limit = 1000;

        Axios.post("auditoria/getHistorialManifiesto",
            {
                // "start": start,
                // "limit": limit,
                // "filtro":{
                //     "idrol": 1
                // }
            },
            {
                headers: headers
            }
        ).then(response => {
            setSpinning(false);
            if (response.data && response.data.data && response.data.data.length > 0) {
                for (let i = 0; i < response.data.data.length; i++) {
                    aux.push({
                        key: response.data.data[i].id,
                        id: response.data.data[i].id,
                        manifiesto: response.data.data[i].manifiesto,
                        fecha_importacion: response.data.data[i].fecha_importacion,
                        importadora: response.data.data[i].importadora,
                        cantidad_facturas: response.data.data[i].cantidad_facturas,
                        idusuario: response.data.data[i].idusuario,
                        nombreusuario: response.data.data[i].nombreusuario,

                    });
                }
            }

            setData(aux);
            setOriginal(aux);
        }).catch(() => {
            setSpinning(false);
        })
    }, [t]);

    useEffect(() => {
        recargar();
    }, [recargar]);

    const filterData = data => formatter => data.map( item => ({
        text: formatter(item),
        value: formatter(item)
    }));

    const columns = [
        {
            title: t('manifiesto.col_manifiesto'),
            dataIndex: 'manifiesto',
            key: 'manifiesto',
            width: 200,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.manifiesto), _.isEqual),
            filteredValue: filteredInfo.manifiesto || null,
            onFilter: (value, record) => record.manifiesto.startsWith(value),
            render: (text) => (
                <span style={{
                    fontWeight: '600',
                    color: '#0F1960',
                    fontSize: '14px'
                }}>
                    {text}
                </span>
            ),
            sorter: (a, b) => a.manifiesto.localeCompare(b.manifiesto),
        },{
            title: t('manifiesto.col_fecha_importacion'),
            dataIndex: 'fecha_importacion',
            key: 'fecha_importacion',
            width: 180,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.fecha_importacion), _.isEqual),
            filteredValue: filteredInfo.fecha_importacion || null,
            onFilter: (value, record) => record.fecha_importacion.startsWith(value),
            render: (text) => (
                <span style={{
                    color: '#495057',
                    fontSize: '13px'
                }}>
                    {text}
                </span>
            ),
            sorter: (a, b) => new Date(a.fecha_importacion) - new Date(b.fecha_importacion),
        },{
            title: t('manifiesto.col_importadora'),
            dataIndex: 'importadora',
            key: 'importadora',
            width: 160,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.importadora), _.isEqual),
            filteredValue: filteredInfo.importadora || null,
            onFilter: (value, record) => record.importadora.startsWith(value),
            render: (text) => (
                <span style={{
                    color: '#6c757d',
                    fontSize: '13px',
                    fontWeight: '500'
                }}>
                    {text}
                </span>
            ),
            sorter: (a, b) => a.importadora.localeCompare(b.importadora),
        },{
            title: t('manifiesto.col_cantidad_facturas'),
            dataIndex: 'cantidad_facturas',
            key: 'cantidad_facturas',
            width: 140,
            align: 'center',
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.cantidad_facturas), _.isEqual),
            filteredValue: filteredInfo.cantidad_facturas || null,
            onFilter: (value, record) => record.cantidad_facturas.toString().startsWith(value),
            render: (value) => (
                <span style={{
                    color: '#0F1960',
                    fontSize: '13px',
                    fontWeight: '600'
                }}>
                    {parseInt(value || 0).toLocaleString()}
                </span>
            ),
            sorter: (a, b) => parseInt(a.cantidad_facturas || 0) - parseInt(b.cantidad_facturas || 0),
        },{
            title: t('manifiesto.col_nombreusuario'),
            dataIndex: 'nombreusuario',
            key: 'nombreusuario',
            width: 160,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.nombreusuario), _.isEqual),
            filteredValue: filteredInfo.nombreusuario || null,
            onFilter: (value, record) => record.nombreusuario.startsWith(value),
            render: (text) => (
                <span style={{
                    color: '#495057',
                    fontSize: '13px',
                    fontWeight: '500'
                }}>
                    {text || 'Sin usuario'}
                </span>
            ),
            sorter: (a, b) => a.nombreusuario.localeCompare(b.nombreusuario),
        }
    ];

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: data.length, // Asegúrate de tener el total de elementos aquí
    });

    const handleTableChange = (newPagination, filters, sorter) => {
        setPagination({
            ...pagination,
            current: newPagination.current,
            pageSize: newPagination.pageSize,
        });
        setFilteredInfo(filters);
    };

    const onSearch = (value) => {
        filterLocal(value);
    };

    const filterLocal = (value) => {
        if(value === "" || value === null){
            setData(original);
        }else{
            let aux = [];
            original.forEach(function(option) {
                if (option.manifiesto.toUpperCase().indexOf(value.toUpperCase()) !== -1) {
                    aux.push(option);
                }
            });
            setData(aux);
        }
    };

    // const onSelectChange = (newSelectedRowKeys) => {
    //     setSelectedRowKeys(newSelectedRowKeys);
    // };

    // Calcular estadísticas
    const estadisticas = useMemo(() => {
        if (!original.length) {
            return {
                totalManifiestos: 0,
                totalFacturas: 0,
                usuarioTop: { nombre: '-', cantidad: 0 }
            };
        }

        // Total de manifiestos
        const totalManifiestos = original.length;

        // Total de facturas
        const totalFacturas = original.reduce((sum, item) => sum + parseInt(item.cantidad_facturas || 0), 0);

        // Usuario que más importaciones realiza
        const usuarioContador = original.reduce((acc, item) => {
            const usuario = item.nombreusuario || 'Sin usuario';
            acc[usuario] = (acc[usuario] || 0) + 1;
            return acc;
        }, {});

        const usuarioTop = Object.entries(usuarioContador).reduce((max, [usuario, cantidad]) => {
            return cantidad > max.cantidad ? { nombre: usuario, cantidad } : max;
        }, { nombre: '-', cantidad: 0 });

        return {
            totalManifiestos,
            totalFacturas,
            usuarioTop
        };
    }, [original]);

    const limpiarFiltros = () => {
        setSearchValue('');
        setData(original);
        setFilteredInfo({});
        setPagination({
            current: 1,
            pageSize: 10,
            total: original.length,
        });
    };

    // Función para obtener vista previa de manifiestos desde API externa
    const fetchManifestPreview = async (values) => {
        const { enterprise, manifest, typecorrespond } = values;

        // URL desde el .env
        const url = process.env.REACT_APP_SOLVED_API_REAL;
        const apikey = "41ypvRfe4qG0qF6Ge96ENEDSTJUzar";

        const params = {
            apikey: apikey,
            data: {
                enterprise: enterprise,
                manifest: manifest,
                typecorrespond: typecorrespond || "f"
            }
        };

        try {
            setSpinTitle(t('manifiesto.loading_preview'));
            setSpinning(true);
            setLoading(true);

            // Llamada a la API externa
            const response = await axios.get(url, {
                params: {
                    apikey: params.apikey,
                    data: JSON.stringify(params.data)
                }
            });

            let rawData;

            // Manejo robusto del parsing de JSON
            try {
                if (typeof response.data === 'string') {
                    // Si la respuesta es string, intentar parsearlo
                    rawData = JSON.parse(response.data);
                } else {
                    // Si ya es objeto, usarlo directamente
                    rawData = response.data;
                }
            } catch (parseError) {
                console.log("Error parsing JSON:", parseError);
                console.log("Raw response data:", response.data);

                // Si hay error de parsing, verificar si contiene el mensaje de error esperado
                const responseText = typeof response.data === 'string' ? response.data : JSON.stringify(response.data);
                if (responseText.includes('"error":"No hay datos para mostrar"')) {
                    // Extraer el mensaje de error del string malformado
                    const errorMatch = responseText.match(/"error":"([^"]+)"/);
                    const errorMessage = errorMatch ? errorMatch[1] : "No hay datos para mostrar";

                    setPreviewData({
                        manifests: [],
                        totalManifests: 1,
                        totalFacturas: 0,
                        enterprise: enterprise,
                        typecorrespond: typecorrespond,
                        isEmpty: true,
                        apiError: errorMessage,
                        searchValues: {
                            enterprise: enterprise,
                            manifest: manifest,
                            typecorrespond: typecorrespond
                        }
                    });
                    setImportFormData(values);
                    setLoading(false);
                    setIsModalImportOpen(false);
                    setIsModalPreviewOpen(true);
                    return;
                } else {
                    // Si no es el error esperado, lanzar el error de parsing
                    throw parseError;
                }
            }

            console.log("Raw API Response:", rawData); // Debug log

            // Verificar si la API retornó un error específico
            if (rawData && rawData.error) {
                console.log("API retornó error:", rawData.error); // Debug log

                // Mostrar vista previa vacía con el mensaje de error de la API
                setPreviewData({
                    manifests: [],
                    totalManifests: 1,
                    totalFacturas: 0,
                    enterprise: enterprise,
                    typecorrespond: typecorrespond,
                    isEmpty: true,
                    apiError: rawData.error, // Guardar el mensaje de error de la API
                    searchValues: {
                        enterprise: enterprise,
                        manifest: manifest,
                        typecorrespond: typecorrespond
                    }
                });
                setImportFormData(values);

                setSpinning(false);
                setLoading(false);
                setIsModalImportOpen(false);
                setIsModalPreviewOpen(true);
                return;
            }

            if (!rawData || typeof rawData !== "object") {
                throw new Error("Datos inválidos recibidos");
            }

            // Transformar los datos según la estructura de manifiestos
            const manifestData = [];

            // Total de facturas = cantidad de claves/keys en la respuesta
            const totalFacturas = Object.keys(rawData).length;
            console.log("Total facturas (keys count):", totalFacturas); // Debug log

            // Verificar si no hay datos (objeto vacío)
            if (totalFacturas === 0) {
                console.log("No se encontraron datos para los valores de búsqueda"); // Debug log

                // Mostrar vista previa vacía
                setPreviewData({
                    manifests: [],
                    totalManifests: 1,
                    totalFacturas: 0,
                    enterprise: enterprise,
                    typecorrespond: typecorrespond,
                    isEmpty: true, // Indicador de búsqueda vacía
                    searchValues: {
                        enterprise: enterprise,
                        manifest: manifest,
                        typecorrespond: typecorrespond
                    }
                });
                setImportFormData(values);

                setSpinning(false);
                setLoading(false);
                setIsModalImportOpen(false);
                setIsModalPreviewOpen(true);
                return;
            }

            // Si rawData es un objeto con keys como códigos de facturas
            Object.keys(rawData).forEach((facturaCode) => {
                const facturaInfo = rawData[facturaCode];

                const formattedManifest = {
                    manifiesto: facturaCode, // Código de la factura
                    fecha_importacion: new Date().toLocaleString('es-ES'),
                    importadora: enterprise,
                    cantidad_facturas: 1, // Cada key representa 1 factura
                    raw_data: facturaInfo // Guardar datos originales
                };

                manifestData.push(formattedManifest);
            });

            // Guardar datos para la vista previa
            setPreviewData({
                manifests: manifestData,
                totalManifests: 1, // Siempre será 1 porque se introduce un solo manifiesto
                totalFacturas: totalFacturas,
                enterprise: enterprise,
                typecorrespond: typecorrespond,
                isEmpty: false
            });
            setImportFormData(values);

            setSpinning(false);
            setLoading(false);
            setIsModalImportOpen(false);
            setIsModalPreviewOpen(true);

        } catch (error) {
            setSpinning(false);
            setLoading(false);
            messageApi.open({
                type: "error",
                content: "Error al obtener vista previa: " + error.message,
                duration: 0,
            });
            setTimeout(messageApi.destroy, 2500);
        }
    };

    // Función para registrar auditoría del manifiesto importado
    const registrarAuditoriaManifiesto = async ({ manifest, typecorrespond, cantidadFacturas }) => {
        try {
            // Obtener datos del usuario desde sessionStorage
            const idusuario = sessionStorage.getItem('idusuario');

            // Obtener info_user y parsearlo
            const infoUserStr = sessionStorage.getItem('info_user');
            let nombreusuario = 'Usuario desconocido';

            if (infoUserStr) {
                try {
                    const infoUser = JSON.parse(infoUserStr);
                    nombreusuario = infoUser.nombreusuario || 'Usuario desconocido';
                } catch (parseError) {
                    console.error("Error parsing info_user:", parseError);
                }
            }

            // Mapear typecorrespond a nombre de importadora
            const importadora = typecorrespond === 'f' ? 'TransCargo' : 'AeroVaradero';

            const auditData = {
                manifiesto: manifest,
                importadora: importadora,
                cantidad_facturas: cantidadFacturas,
                idusuario: parseInt(idusuario) || 0,
                nombreusuario: nombreusuario
            };

            console.log("Registrando auditoría del manifiesto:", auditData);

            await Axios.post("/auditoria/registrarAuditoriaManifiesto", auditData, {
                headers: headers
            });

            console.log("Auditoría registrada exitosamente");

        } catch (error) {
            console.error("Error al registrar auditoría del manifiesto:", error);
            // No lanzamos el error para que no afecte el flujo principal de importación
        }
    };

    // Función para verificar si el manifiesto ya fue importado
    const verificarManifiestoImportado = async (manifest) => {
        try {
            const response = await Axios.post("/auditoria/verificarManifiestoImportado", {
                manifiesto: manifest
            }, {
                headers: headers
            });

            if (response.data.success && response.data.data && response.data.data.length > 0) {
                const manifestInfo = response.data.data[0];
                return {
                    existe: manifestInfo.existe > 0,
                    importado: manifestInfo.importado === "SI",
                    detalles: manifestInfo
                };
            }

            return { existe: false, importado: false, detalles: null };
        } catch (error) {
            console.error("Error al verificar manifiesto:", error);
            // En caso de error, permitir continuar (asumir que no existe)
            return { existe: false, importado: false, detalles: null };
        }
    };

    // Función para confirmar e importar los datos
    const confirmImport = async () => {
        if (!previewData || !importFormData) return;

        try {
            setSpinTitle('Verificando manifiesto...');
            setSpinning(true);
            setLoading(true);

            // Obtener datos del formulario
            const { enterprise, manifest, typecorrespond } = importFormData;

            // Verificar si el manifiesto ya fue importado
            const verificacion = await verificarManifiestoImportado(manifest);

            if (verificacion.importado) {
                setSpinning(false);
                setLoading(false);

                // Guardar datos del duplicado y mostrar modal
                setDuplicateData({
                    manifest: manifest,
                    detalles: verificacion.detalles
                });
                setIsModalDuplicateOpen(true);
                return;
            }

            // Si no existe o no fue importado, continuar con la importación
            setSpinTitle(t('manifiesto.importing_data'));

            // URL desde el .env
            const url = process.env.REACT_APP_SOLVED_API_REAL;
            const apikey = "41ypvRfe4qG0qF6Ge96ENEDSTJUzar";

            const params = {
                apikey: apikey,
                data: {
                    enterprise: enterprise,
                    manifest: manifest,
                    typecorrespond: typecorrespond || "f"
                }
            };

            // Llamada a la API externa para obtener datos completos
            const response = await axios.get(url, {
                params: {
                    apikey: params.apikey,
                    data: JSON.stringify(params.data)
                }
            });

            let rawData;

            // Manejo robusto del parsing de JSON
            try {
                if (typeof response.data === 'string') {
                    rawData = JSON.parse(response.data);
                } else {
                    rawData = response.data;
                }
            } catch (parseError) {
                console.log("Error parsing JSON during import:", parseError);
                throw new Error("Error al procesar los datos de la API");
            }

            // Verificar si hay error o datos vacíos
            if (rawData && rawData.error) {
                throw new Error(rawData.error);
            }

            if (!rawData || typeof rawData !== "object" || Object.keys(rawData).length === 0) {
                throw new Error("No hay datos para importar");
            }

            // Formatear datos como en el componente Facturas
            const formattedData = Object.keys(rawData).map((code) => ({
                code,
                ...rawData[code],
            }));

            console.log("Raw data recibida de la API:", JSON.stringify(rawData, null, 2));

            const invoiceData = [];

            // Recorrer el resultado de la API (igual que en Facturas.js)
            formattedData.forEach((invoice) => {
                const formattedInvoice = {
                    code: invoice.code,
                    rdatereserve: invoice.rdatereserve,
                    iddeliverstate: invoice.iddeliverstate, //id del estado
                    deliverstate: invoice.deliverstate, // denominacion de estado
                    consignee: invoice.consignee, // destinatario
                    shipper: invoice.shipper, // remitente
                    products: invoice.products, // Asumiendo que los productos ya tienen el formato correcto
                };

                // Agregar la factura formateada al array invoiceData
                invoiceData.push(formattedInvoice);
            });

            console.log("Muestra de datos de una factura:", JSON.stringify(formattedData[0], null, 2));

            console.log("Datos a enviar a addInvoiceProducts:", invoiceData);

            // Enviar al servicio addInvoiceProducts (igual que en Facturas.js)
            const importResponse = await Axios.post("/sd/addInvoiceProducts", invoiceData, {
                headers: headers,
            });

            setSpinning(false);
            setLoading(false);

            if (importResponse.data.success) {
                // Registrar auditoría de la importación
                await registrarAuditoriaManifiesto({
                    manifest: manifest,
                    typecorrespond: typecorrespond,
                    cantidadFacturas: invoiceData.length
                });

                messageApi.open({
                    type: "success",
                    content: importResponse.data.message,
                    duration: 0,
                });
                setTimeout(messageApi.destroy, 2500);

                // Recargar datos locales
                recargar();

                // Cerrar modal y limpiar estados
                setIsModalPreviewOpen(false);
                setPreviewData(null);
                setImportFormData(null);
            } else {
                messageApi.open({
                    type: "error",
                    content: importResponse.data.message,
                    duration: 0,
                });
                setTimeout(messageApi.destroy, 2500);
            }

        } catch (error) {
            console.error("Error durante la importación:", error);
            setSpinning(false);
            setLoading(false);
            messageApi.open({
                type: "error",
                content: "Error al importar datos: " + error.message,
                duration: 0,
            });
            setTimeout(messageApi.destroy, 2500);
        }
    };


    // Definir headers fuera de useCallback para evitar problemas de dependencias
    const headers = {
        'accept': '*/*',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
    };

    // Handlers para el modal de importación
    const showModalImport = () => {
        // Resetear el formulario completamente
        formImport.resetFields();
        // Inicializar con los valores por defecto
        setFormValues({
            enterprise: "etcexpress",
            typecorrespond: "f"
        });
        setIsModalImportOpen(true);
    };

    const handleCancelImport = () => {
        formImport.resetFields();
        setFormValues({});
        setIsModalImportOpen(false);
    };

    const handleCancelPreview = () => {
        setIsModalPreviewOpen(false);
        setPreviewData(null);
        setImportFormData(null);
        // Limpiar estados del spinner
        setSpinning(false);
        setLoading(false);
        setSpinTitle('');
    };

    const handleCloseDuplicate = () => {
        setIsModalDuplicateOpen(false);
        setDuplicateData(null);
    };

    const onFinishImport = (values) => {
        fetchManifestPreview(values);
    };

    const onFormValuesChange = (changedValues, allValues) => {
        setFormValues(allValues);
    };

    return (
        <div style={{
            minHeight: "100vh",
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            padding: "16px"
        }}>
            <Spin spinning={spinning} tip={spinTitle} size={"large"}>
                <div style={{
                    maxWidth: "1400px",
                    margin: "0 auto"
                }}>
                    {/* Header Card */}
                    <Card style={{
                        borderRadius: '8px',
                        marginBottom: '12px',
                        background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                        border: 'none',
                        boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <div style={{
                                background: 'rgba(255,255,255,0.2)',
                                borderRadius: '50%',
                                width: '32px',
                                height: '32px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '16px'
                            }}>
                                <FileTextOutlined style={{ color: 'white' }} />
                            </div>
                            <div style={{ flex: 1 }}>
                                <Title level={4} style={{
                                    color: 'white',
                                    margin: 0,
                                    fontSize: '16px',
                                    fontWeight: '600'
                                }}>
                                    {t('manifiesto.title')}
                                </Title>
                                <p style={{
                                    color: 'rgba(255,255,255,0.9)',
                                    margin: 0,
                                    fontSize: '12px',
                                    marginTop: '2px'
                                }}>
                                    Manifiestos • {data.length} registros
                                </p>
                            </div>
                        </div>
                    </Card>

                    {contextHolder}

                {/* Sección de Estadísticas */}
                <Row gutter={[12, 12]} style={{ marginBottom: 12 }}>
                    <Col xs={24} sm={8} md={8}>
                        <Card
                            style={{
                                background: 'linear-gradient(135deg, #0F1960 0%, #3949ab 100%)',
                                border: 'none',
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(15, 25, 96, 0.2)',
                                height: '100px',
                                padding: '8px',
                                position: 'relative',
                                overflow: 'hidden'
                            }}
                            styles={{
                                body: {
                                    padding: 0,
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between'
                                }
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: '4px'
                            }}>
                                <FaBoxes style={{
                                    fontSize: '14px',
                                    color: '#7986cb',
                                    marginRight: '6px'
                                }} />
                                <span style={{
                                    color: 'rgba(255,255,255,0.9)',
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px',
                                    textTransform: 'uppercase'
                                }}>
                                    {t('manifiesto.estadisticas.total_manifiestos')}
                                </span>
                            </div>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flex: 1
                            }}>
                                <span style={{
                                    color: 'white',
                                    fontSize: '24px',
                                    fontWeight: '700',
                                    lineHeight: '1',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
                                }}>
                                    {estadisticas.totalManifiestos}
                                </span>
                            </div>
                        </Card>
                    </Col>
                    <Col xs={24} sm={8} md={8}>
                        <Card
                            style={{
                                background: 'linear-gradient(135deg, #0F1960 0%, #3949ab 100%)',
                                border: 'none',
                                borderRadius: '8px',
                                boxShadow: '0 8px 24px rgba(15, 25, 96, 0.2)',
                                height: '100px',
                                padding: '8px',
                                position: 'relative',
                                overflow: 'hidden'
                            }}
                            styles={{
                                body: {
                                    padding: 0,
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between'
                                }
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: '4px'
                            }}>
                                <FaFileInvoice style={{
                                    fontSize: '14px',
                                    color: '#9575cd',
                                    marginRight: '4px'
                                }} />
                                <span style={{
                                    color: 'rgba(255,255,255,0.9)',
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px',
                                    textTransform: 'uppercase'
                                }}>
                                    {t('manifiesto.estadisticas.total_facturas')}
                                </span>
                            </div>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flex: 1
                            }}>
                                <span style={{
                                    color: 'white',
                                    fontSize: '24px',
                                    fontWeight: '700',
                                    lineHeight: '1',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
                                }}>
                                    {estadisticas.totalFacturas.toLocaleString()}
                                </span>
                            </div>
                        </Card>
                    </Col>
                    <Col xs={24} sm={8} md={8}>
                        <Card
                            style={{
                                background: 'linear-gradient(135deg, #0F1960 0%, #3949ab 100%)',
                                border: 'none',
                                borderRadius: '8px',
                                boxShadow: '0 8px 24px rgba(15, 25, 96, 0.2)',
                                height: '100px',
                                padding: '8px',
                                position: 'relative',
                                overflow: 'hidden'
                            }}
                            styles={{
                                body: {
                                    padding: 0,
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between'
                                }
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: '4px'
                            }}>
                                <FaUserTie style={{
                                    fontSize: '14px',
                                    color: '#ba68c8',
                                    marginRight: '4px'
                                }} />
                                <span style={{
                                    color: 'rgba(255,255,255,0.9)',
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px',
                                    textTransform: 'uppercase'
                                }}>
                                    {t('manifiesto.estadisticas.usuario_top')}
                                </span>
                            </div>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flex: 1,
                                textAlign: 'center'
                            }}>
                                <div style={{
                                    color: 'white',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    marginBottom: '4px',
                                    maxWidth: '100%',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                }}>
                                    {estadisticas.usuarioTop.nombre}
                                </div>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'baseline',
                                    justifyContent: 'center'
                                }}>
                                    <span style={{
                                        color: 'white',
                                        fontSize: '18px',
                                        fontWeight: '700',
                                        lineHeight: '1',
                                        textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
                                    }}>
                                        {estadisticas.usuarioTop.cantidad}
                                    </span>
                                    <span style={{
                                        color: 'rgba(255,255,255,0.7)',
                                        fontSize: '11px',
                                        fontWeight: '500',
                                        marginLeft: '4px',
                                        textTransform: 'lowercase'
                                    }}>
                                        {t('manifiesto.estadisticas.importaciones')}
                                    </span>
                                </div>
                            </div>
                        </Card>
                    </Col>
                </Row>
                    {/* Toolbar Card */}
                    <Card style={{
                        borderRadius: '8px',
                        marginBottom: '12px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        border: '1px solid #e0e6ff'
                    }}
                    styles={{ body: { padding: '12px' } }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            flexWrap: 'wrap'
                        }}>
                            <Button
                                icon={<CloudDownloadOutlined />}
                                onClick={showModalImport}
                                size="small"
                                style={{
                                    background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                    borderColor: '#253289',
                                    color: 'white',
                                    borderRadius: '8px',
                                    height: '40px',
                                    paddingLeft: '16px',
                                    paddingRight: '16px',
                                    fontWeight: '500',
                                    boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
                                }}
                            >
                                {t('manifiesto.import')}
                            </Button>
                            <Button
                                icon={<ReloadOutlined />}
                                onClick={recargar}
                                loading={loading}
                                size="small"
                                style={{
                                    background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                    borderColor: '#253289',
                                    color: 'white',
                                    borderRadius: '8px',
                                    height: '40px',
                                    paddingLeft: '16px',
                                    paddingRight: '16px',
                                    fontWeight: '500',
                                    boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
                                }}
                            >
                                {t('global.reload')}
                            </Button>
                            <Button
                                icon={<ClearOutlined />}
                                onClick={limpiarFiltros}
                                size="small"
                                style={{
                                    borderColor: '#253289',
                                    color: '#253289',
                                    background: 'white',
                                    borderRadius: '8px',
                                    height: '40px',
                                    paddingLeft: '16px',
                                    paddingRight: '16px',
                                    fontWeight: '500'
                                }}
                            >
                                {t('global.clear_filters')}
                            </Button>
                        </div>
                    </Card>



                    {/* Table Card */}
                    <Card style={{
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        border: '1px solid #e0e6ff'
                    }}>
                        {/* Header de la tabla con búsqueda */}
                        <div style={{
                            background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                            padding: '12px 16px',
                            borderRadius: '6px 6px 0 0',
                            marginBottom: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexWrap: 'wrap',
                            gap: '12px'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px'
                            }}>
                                <span style={{
                                    color: '#253289',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    📋 Historial de Manifiestos
                                </span>
                                <span style={{
                                    background: '#e3f2fd',
                                    color: '#253289',
                                    padding: '4px 8px',
                                    borderRadius: '6px',
                                    fontSize: '12px',
                                    fontWeight: '500'
                                }}>
                                    {data.length} registro{data.length !== 1 ? 's' : ''}
                                </span>
                            </div>

                            {/* Búsqueda en tabla */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>
                                <span style={{
                                    color: '#495057',
                                    fontSize: '13px',
                                    fontWeight: '500',
                                    minWidth: 'max-content'
                                }}>
                                    🔍 Filtrar:
                                </span>
                                <Search
                                    placeholder={t('manifiesto.search')}
                                    style={{
                                        maxWidth: '280px',
                                        width: '100%',
                                        height: '36px'
                                    }}
                                    size="middle"
                                    onSearch={onSearch}
                                    value={searchValue}
                                    onChange={(e) => {
                                        setSearchValue(e.target.value);
                                        filterLocal(e.target.value);
                                    }}
                                />
                                {searchValue && (
                                    <span style={{
                                        background: '#fff3cd',
                                        color: '#856404',
                                        padding: '3px 8px',
                                        borderRadius: '8px',
                                        fontSize: '11px',
                                        fontWeight: '500',
                                        border: '1px solid #ffeaa7'
                                    }}>
                                        "{searchValue}"
                                    </span>
                                )}
                            </div>
                        </div>

                    <Table
                        size="middle"
                        scroll={{
                            x: 1200,
                            y: 600,
                        }}
                        bordered={false}
                        pagination={{
                            position: ['bottomCenter'],
                            current: pagination.current,
                            pageSize: pagination.pageSize,
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '20', '50', '100'],
                            showTotal: (total, range) => (
                                <span style={{
                                    color: '#253289',
                                    fontWeight: '500'
                                }}>
                                    {`${range[0]}-${range[1]} de ${total} registros`}
                                </span>
                            ),
                            showQuickJumper: true,
                            showLessItems: true,
                            style: {
                                marginTop: '16px'
                            }
                        }}
                        onChange={handleTableChange}
                        columns={columns}
                        dataSource={data}
                        rowClassName={(record, index) => {
                            return index % 2 === 0 ? 'ant-table-row-even' : 'ant-table-row-odd';
                        }}
                        locale={{
                            emptyText: (
                                <div style={{
                                    padding: '40px',
                                    textAlign: 'center',
                                    color: '#6c757d'
                                }}>
                                    <div style={{ fontSize: '48px', marginBottom: '16px' }}>📋</div>
                                    <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>
                                        No hay datos disponibles
                                    </div>
                                    <div style={{ fontSize: '14px' }}>
                                        {searchValue ? 'Intenta ajustar los filtros de búsqueda' : 'Carga algunos manifiestos para verlos aquí'}
                                    </div>
                                </div>
                            )
                        }}
                        style={{
                            background: 'white',
                            borderRadius: '8px'
                        }}
                    />
                    </Card>

                {/* Modal para importar manifiestos */}
                <Modal
                    title={null}
                    open={isModalImportOpen}
                    onCancel={handleCancelImport}
                    footer={null}
                    width={550}
                    centered
                    styles={{
                        content: {
                            padding: 0,
                            borderRadius: '12px',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)'
                        },
                        body: {
                            padding: 0
                        }
                    }}
                >
                    <div>
                        {/* Header del modal */}
                        <div style={{
                            background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                            borderRadius: '12px 12px 0 0',
                            padding: '24px',
                            color: 'white',
                            textAlign: 'center',
                            flexShrink: 0
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '16px'
                            }}>
                                <div style={{
                                    background: 'rgba(255,255,255,0.2)',
                                    borderRadius: '50%',
                                    width: '48px',
                                    height: '48px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '20px'
                                }}>
                                    <CloudDownloadOutlined style={{ color: 'white' }} />
                                </div>
                                <div style={{ textAlign: 'left' }}>
                                    <Typography.Title level={3} style={{
                                        color: 'white',
                                        margin: 0,
                                        fontSize: '20px'
                                    }}>
                                        {t('manifiesto.import_form')}
                                    </Typography.Title>
                                    <Typography.Text style={{
                                        color: 'rgba(255,255,255,0.8)',
                                        fontSize: '14px',
                                        display: 'block',
                                        marginTop: '4px'
                                    }}>
                                        Importar manifiestos desde API externa
                                    </Typography.Text>
                                </div>
                            </div>
                        </div>

                        {/* Contenido del modal */}
                        <div style={{ padding: '20px' }}>
                            <Form
                                form={formImport}
                                onFinish={onFinishImport}
                                onValuesChange={onFormValuesChange}
                                layout="vertical"
                            >
                                <div style={{
                                    background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                    borderRadius: '8px',
                                    padding: '16px',
                                    marginBottom: '16px',
                                    border: '1px solid #e0e6ff'
                                }}>
                                    <h4 style={{
                                        color: '#253289',
                                        marginBottom: '12px',
                                        fontSize: '14px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px'
                                    }}>
                                        🏢 Información de la Empresa
                                    </h4>
                                    <Form.Item
                                        name="enterprise"
                                        label={t('manifiesto.enterprise')}
                                        initialValue={"etcexpress"}
                                        rules={[
                                            { required: true, message: t('manifiesto.enterprise_required') }
                                        ]}
                                        style={{ marginBottom: 0 }}
                                    >
                                        <Input
                                            placeholder={t('manifiesto.enterprise')}
                                            style={{ height: '36px' }}
                                        />
                                    </Form.Item>
                                </div>

                                <div style={{
                                    background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                    borderRadius: '8px',
                                    padding: '16px',
                                    marginBottom: '16px',
                                    border: '1px solid #e0e6ff'
                                }}>
                                    <h4 style={{
                                        color: '#253289',
                                        marginBottom: '12px',
                                        fontSize: '14px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px'
                                    }}>
                                        📦 Código del Manifiesto
                                    </h4>
                                    <Form.Item
                                        name="manifest"
                                        label={t('manifiesto.manifest_code')}
                                        rules={[
                                            { required: true, message: t('manifiesto.manifest_required') }
                                        ]}
                                        style={{ marginBottom: 0 }}
                                    >
                                        <Input
                                            placeholder={t('manifiesto.manifest_placeholder')}
                                            style={{ height: '36px' }}
                                        />
                                    </Form.Item>
                                </div>

                                <div style={{
                                    background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                    borderRadius: '8px',
                                    padding: '16px',
                                    marginBottom: '16px',
                                    border: '1px solid #e0e6ff'
                                }}>
                                    <h4 style={{
                                        color: '#253289',
                                        marginBottom: '12px',
                                        fontSize: '14px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px'
                                    }}>
                                        🚚 Tipo de Correspondencia
                                    </h4>
                                    <Form.Item
                                        name="typecorrespond"
                                        label={t('manifiesto.type_correspond')}
                                        initialValue={"f"}
                                        style={{ marginBottom: 0 }}
                                    >
                                        <Select
                                            placeholder={t('manifiesto.type_correspond_placeholder')}
                                            style={{ height: '36px' }}
                                        >
                                            <Select.Option value="f">TransCargo</Select.Option>
                                            <Select.Option value="a">AeroVaradero</Select.Option>
                                        </Select>
                                    </Form.Item>
                                </div>

                                <Form.Item>
                                    <div style={{
                                        textAlign: "center",
                                        paddingTop: '12px',
                                        borderTop: '1px solid #f0f0f0',
                                        marginTop: '4px'
                                    }}>
                                        <Button
                                            type="default"
                                            icon={<CloseOutlined />}
                                            onClick={handleCancelImport}
                                            style={{
                                                marginRight: 12,
                                                borderColor: '#dc3545',
                                                color: '#dc3545',
                                                height: '36px',
                                                paddingLeft: '16px',
                                                paddingRight: '16px',
                                                fontWeight: '500'
                                            }}
                                        >
                                            {t("global.cancel")}
                                        </Button>
                                        <Button
                                            type="primary"
                                            icon={<CloudDownloadOutlined />}
                                            htmlType="submit"
                                            loading={loading}
                                            disabled={!formValues.enterprise || !formValues.manifest}
                                            style={{
                                                background: (!formValues.enterprise || !formValues.manifest)
                                                    ? '#d9d9d9'
                                                    : 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                                borderColor: (!formValues.enterprise || !formValues.manifest)
                                                    ? '#d9d9d9'
                                                    : '#253289',
                                                color: (!formValues.enterprise || !formValues.manifest)
                                                    ? '#000000'
                                                    : 'white',
                                                height: '36px',
                                                paddingLeft: '16px',
                                                paddingRight: '16px',
                                                fontWeight: '500',
                                                boxShadow: (!formValues.enterprise || !formValues.manifest)
                                                    ? 'none'
                                                    : '0 2px 8px rgba(37, 50, 137, 0.3)'
                                            }}
                                        >
                                            Buscar Manifiesto
                                        </Button>
                                    </div>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                </Modal>

                {/* Modal de Vista Previa */}
                <Modal
                    title={null}
                    open={isModalPreviewOpen}
                    onCancel={handleCancelPreview}
                    footer={null}
                    width={650}
                    style={{ top: 10 }}
                    styles={{
                        content: {
                            padding: 0,
                            borderRadius: '12px',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
                            maxHeight: 'calc(100vh - 40px)',
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column'
                        },
                        body: {
                            padding: 0,
                            flex: 1,
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column'
                        }
                    }}
                >
                    {/* Header del modal */}
                    <div style={{
                        background: 'linear-gradient(135deg, #0F1960 0%, #3949ab 100%)',
                        borderRadius: '12px 12px 0 0',
                        padding: '24px',
                        color: 'white',
                        textAlign: 'center',
                        flexShrink: 0
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '16px'
                        }}>
                            <div style={{
                                background: 'rgba(255,255,255,0.2)',
                                borderRadius: '50%',
                                width: '48px',
                                height: '48px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '20px'
                            }}>
                                📋
                            </div>
                            <div style={{ textAlign: 'left' }}>
                                <Typography.Title level={3} style={{
                                    color: 'white',
                                    margin: 0,
                                    fontSize: '20px'
                                }}>
                                    Vista Previa de Importación
                                </Typography.Title>
                                <Typography.Text style={{
                                    color: 'rgba(255,255,255,0.8)',
                                    fontSize: '14px',
                                    display: 'block',
                                    marginTop: '4px'
                                }}>
                                    Revisar datos antes de importar al sistema
                                </Typography.Text>
                            </div>
                        </div>
                    </div>
                    {previewData && (
                        <div style={{
                            padding: '15px 20px',
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: 0
                        }}>
                            {/* Resumen General */}
                            <div style={{
                                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                borderRadius: '8px',
                                padding: '15px',
                                marginBottom: '15px',
                                border: '1px solid #dee2e6'
                            }}>
                                <h3 style={{
                                    margin: '0 0 12px 0',
                                    color: '#0F1960',
                                    fontSize: '15px',
                                    fontWeight: '600'
                                }}>
                                    📊 Resumen de Importación
                                </h3>

                                <Row gutter={12}>
                                    <Col span={8}>
                                        <div style={{
                                            textAlign: 'center',
                                            background: 'white',
                                            padding: '15px 12px',
                                            borderRadius: '8px',
                                            border: '1px solid #e9ecef',
                                            minHeight: '80px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center'
                                        }}>
                                            <div style={{ fontSize: '22px', fontWeight: 'bold', color: '#0F1960', lineHeight: '1' }}>
                                                {previewData.totalManifests}
                                            </div>
                                            <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '6px', fontWeight: '500' }}>
                                                Manifiesto
                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div style={{
                                            textAlign: 'center',
                                            background: 'white',
                                            padding: '15px 12px',
                                            borderRadius: '8px',
                                            border: '1px solid #e9ecef',
                                            minHeight: '80px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center'
                                        }}>
                                            <div style={{ fontSize: '22px', fontWeight: 'bold', color: '#28a745', lineHeight: '1' }}>
                                                {previewData.totalFacturas}
                                            </div>
                                            <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '6px', fontWeight: '500' }}>
                                                Total Facturas
                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div style={{
                                            textAlign: 'center',
                                            background: 'white',
                                            padding: '15px 12px',
                                            borderRadius: '8px',
                                            border: '1px solid #e9ecef',
                                            minHeight: '80px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center'
                                        }}>
                                            <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#0F1960', lineHeight: '1.2', wordBreak: 'break-word' }}>
                                                {importFormData?.manifest || 'N/A'}
                                            </div>
                                            <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '6px', fontWeight: '500' }}>
                                                Código Manifiesto
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            {/* Detalle de Manifiestos */}
                            <div style={{
                                background: 'white',
                                borderRadius: '8px',
                                border: '1px solid #dee2e6',
                                overflow: 'hidden',
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                minHeight: 0
                            }}>
                                <div style={{
                                    background: '#f8f9fa',
                                    padding: '12px 15px',
                                    borderBottom: '1px solid #dee2e6'
                                }}>
                                    <h3 style={{
                                        margin: 0,
                                        color: '#0F1960',
                                        fontSize: '14px',
                                        fontWeight: '600'
                                    }}>
                                        📋 Detalle de Manifiestos
                                    </h3>
                                </div>

                                <div style={{
                                    flex: 1,
                                    overflowY: 'auto',
                                    padding: '0',
                                    minHeight: 0
                                }}>
                                    {previewData.isEmpty ? (
                                        <div style={{
                                            padding: '40px 20px',
                                            textAlign: 'center',
                                            background: '#f8f9fa'
                                        }}>
                                            <div style={{
                                                fontSize: '48px',
                                                marginBottom: '16px',
                                                color: '#6c757d'
                                            }}>
                                                🔍
                                            </div>
                                            <div style={{
                                                fontSize: '16px',
                                                fontWeight: '600',
                                                color: '#495057',
                                                marginBottom: '4px'
                                            }}>
                                                Sin resultados encontrados
                                            </div>
                                            <div style={{
                                                fontSize: '14px',
                                                color: '#6c757d',
                                                marginBottom: '12px'
                                            }}>
                                                {previewData.apiError ? previewData.apiError : 'No se encontró información para los valores de búsqueda:'}
                                            </div>
                                            {previewData.apiError && (
                                                <div style={{
                                                    background: '#fff3cd',
                                                    color: '#856404',
                                                    border: '1px solid #ffeaa7',
                                                    borderRadius: '6px',
                                                    padding: '8px 12px',
                                                    fontSize: '12px',
                                                    marginBottom: '12px',
                                                    fontWeight: '500'
                                                }}>
                                                    Mensaje del servidor: "{previewData.apiError}"
                                                </div>
                                            )}
                                            {!previewData.apiError && (
                                                <div style={{
                                                    background: 'white',
                                                    border: '1px solid #dee2e6',
                                                    borderRadius: '6px',
                                                    padding: '12px',
                                                    fontSize: '13px',
                                                    color: '#495057'
                                                }}>
                                                    <div><strong>Empresa:</strong> {previewData.searchValues?.enterprise}</div>
                                                    <div><strong>Manifiesto:</strong> {previewData.searchValues?.manifest}</div>
                                                    <div><strong>Tipo:</strong> {previewData.searchValues?.typecorrespond === 'f' ? 'TransCargo' : 'AeroVaradero'}</div>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        previewData.manifests.map((manifest, index) => (
                                            <div key={index} style={{
                                                padding: '12px 15px',
                                                borderBottom: index < previewData.manifests.length - 1 ? '1px solid #f0f0f0' : 'none',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                background: index % 2 === 0 ? '#fafafa' : 'white'
                                            }}>
                                                <div>
                                                    <div style={{
                                                        fontWeight: '600',
                                                        color: '#0F1960',
                                                        fontSize: '14px',
                                                        marginBottom: '4px'
                                                    }}>
                                                        {manifest.manifiesto}
                                                    </div>
                                                    <div style={{
                                                        fontSize: '12px',
                                                        color: '#6c757d'
                                                    }}>
                                                        {manifest.importadora}
                                                    </div>
                                                </div>
                                                <div style={{
                                                    background: manifest.cantidad_facturas > 0 ? '#d4edda' : '#f8d7da',
                                                    color: manifest.cantidad_facturas > 0 ? '#155724' : '#721c24',
                                                    padding: '6px 12px',
                                                    borderRadius: '20px',
                                                    fontSize: '12px',
                                                    fontWeight: '600'
                                                }}>
                                                    {manifest.cantidad_facturas} facturas
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>

                            {/* Botones de Acción */}
                            <div style={{
                                textAlign: "center",
                                marginTop: '15px',
                                paddingTop: '15px',
                                borderTop: '1px solid #dee2e6',
                                flexShrink: 0
                            }}>
                                <Button
                                    type="default"
                                    icon={<CloseOutlined />}
                                    size="large"
                                    onClick={handleCancelPreview}
                                    style={{
                                        marginRight: 12,
                                        borderColor: '#dc3545',
                                        color: '#dc3545',
                                        fontWeight: '600'
                                    }}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    type="primary"
                                    icon={<ImportOutlined />}
                                    size="large"
                                    onClick={confirmImport}
                                    loading={loading}
                                    disabled={!previewData || previewData.totalFacturas === 0}
                                    style={{
                                        background: (!previewData || previewData.totalFacturas === 0) ? '#d9d9d9' : '#28a745',
                                        borderColor: (!previewData || previewData.totalFacturas === 0) ? '#d9d9d9' : '#28a745',
                                        color: (!previewData || previewData.totalFacturas === 0) ? '#999999' : 'white',
                                        opacity: (!previewData || previewData.totalFacturas === 0) ? 0.6 : 1,
                                        fontWeight: '600',
                                        minWidth: '120px'
                                    }}
                                >
                                    Importar
                                </Button>
                            </div>
                        </div>
                    )}
                </Modal>

                {/* Modal de Manifiesto Duplicado */}
                <Modal
                    title={null}
                    open={isModalDuplicateOpen}
                    onCancel={handleCloseDuplicate}
                    footer={null}
                    width={550}
                    centered
                    closable={false}
                    maskClosable={false}
                    styles={{
                        content: {
                            padding: 0,
                            borderRadius: '12px',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)'
                        },
                        body: {
                            padding: 0
                        }
                    }}
                >
                    {duplicateData && (
                        <div style={{
                            textAlign: 'center',
                            padding: '20px 10px'
                        }}>
                            {/* Icono de advertencia */}
                            <div style={{
                                fontSize: '64px',
                                marginBottom: '20px',
                                background: 'linear-gradient(45deg, #ff9800, #f57c00)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text'
                            }}>
                                ⚠️
                            </div>

                            {/* Título */}
                            <div style={{
                                fontSize: '24px',
                                fontWeight: '700',
                                color: '#d84315',
                                marginBottom: '15px',
                                fontFamily: "'Roboto', sans-serif"
                            }}>
                                Manifiesto Ya Importado
                            </div>

                            {/* Mensaje principal */}
                            <div style={{
                                fontSize: '16px',
                                color: '#424242',
                                marginBottom: '25px',
                                lineHeight: '1.5'
                            }}>
                                El manifiesto <strong style={{ color: '#0F1960' }}>"{duplicateData.manifest}"</strong> ya fue procesado anteriormente.
                            </div>

                            {/* Tarjeta con detalles */}
                            <div style={{
                                background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)',
                                borderRadius: '12px',
                                padding: '20px',
                                marginBottom: '25px',
                                border: '1px solid #ffcc02',
                                boxShadow: '0 2px 8px rgba(255, 152, 0, 0.15)'
                            }}>
                                <div style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#e65100',
                                    marginBottom: '12px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}>
                                    Detalles de la Importación Anterior
                                </div>

                                <div style={{ textAlign: 'left' }}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        marginBottom: '4px',
                                        padding: '6px 0',
                                        borderBottom: '1px solid rgba(229, 115, 115, 0.2)'
                                    }}>
                                        <span style={{ color: '#6d4c41', fontWeight: '600' }}>📅 Fecha:</span>
                                        <span style={{ color: '#0F1960', fontWeight: '500' }}>{duplicateData.detalles.ultima_importacion}</span>
                                    </div>

                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        marginBottom: '4px',
                                        padding: '6px 0',
                                        borderBottom: '1px solid rgba(229, 115, 115, 0.2)'
                                    }}>
                                        <span style={{ color: '#6d4c41', fontWeight: '600' }}>🏢 Importadora:</span>
                                        <span style={{ color: '#0F1960', fontWeight: '500' }}>{duplicateData.detalles.ultima_importadora}</span>
                                    </div>

                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        padding: '6px 0'
                                    }}>
                                        <span style={{ color: '#6d4c41', fontWeight: '600' }}>📦 Facturas:</span>
                                        <span style={{ color: '#0F1960', fontWeight: '500' }}>{duplicateData.detalles.ultima_cantidad_facturas}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Mensaje de restricción */}
                            <div style={{
                                background: '#ffebee',
                                color: '#c62828',
                                padding: '12px 16px',
                                borderRadius: '8px',
                                marginBottom: '25px',
                                border: '1px solid #ffcdd2',
                                fontSize: '14px',
                                fontWeight: '500'
                            }}>
                                🚫 No es posible importar nuevamente el mismo manifiesto
                            </div>

                            {/* Botón de cerrar */}
                            <Button
                                type="primary"
                                size="large"
                                onClick={handleCloseDuplicate}
                                style={{
                                    background: 'linear-gradient(135deg, #0F1960 0%, #3949ab 100%)',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontWeight: '600',
                                    fontSize: '16px',
                                    height: '48px',
                                    minWidth: '120px',
                                    boxShadow: '0 4px 12px rgba(15, 25, 96, 0.3)'
                                }}
                            >
                                Entendido
                            </Button>
                        </div>
                    )}
                </Modal>

                </div>
            </Spin>
        </div>
    );
};

export default Manifiesto;